import styled, { css } from 'styled-components';

import Picture from 'components/picture';
import { delayUnmountHOC } from 'utils/delay-unmount-hoc';

export const CATEGORY_TRANSITION_TIME = 350;

const RewardContainer = styled.div``;
const CATEGORY_HEADER_HEIGHT = '2.75rem';
const CATEGORY_HEADER_WIDTH = '23.4375rem;';

export const DelayedUnmountRewardContainer = delayUnmountHOC(RewardContainer);

export const StyledIconArrowDown = styled.div`
  margin-left: auto;
`;

export const RewardCategory = styled.li<{
  open: boolean;
  categoryHeight: number;
  isCurrentSelection: boolean;
}>`
  height: ${p => `calc(${p.open ? p.categoryHeight : 0}rem + ${CATEGORY_HEADER_HEIGHT})`};
  width: ${CATEGORY_HEADER_WIDTH};
  display: flex;
  width: 100%;
  transition: height ${CATEGORY_TRANSITION_TIME / 1000}s;
  overflow: hidden;
  flex-direction: column;
  background: ${Styles.color.white};

  ${p =>
    p.isCurrentSelection &&
    css`
      position: relative;
      z-index: ${Styles.zIndex.top};
    `}

  ${StyledIconArrowDown} {
    ${p =>
      p.open &&
      css`
        transition: 0.35s;
        transform: rotate(180deg);
      `}
  }
`;

export const CategoryHeader = styled.div`
  height: ${CATEGORY_HEADER_HEIGHT};
  flex-shrink: 0;
  width: ${CATEGORY_HEADER_WIDTH};
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid ${Styles.color.grey.four};
  background-color: ${Styles.color.white};
  padding: 0 1rem;
`;

export const CategoryImage = styled(Picture)`
  height: 1.7rem;
  width: 1.7rem;
  margin-right: 0.75rem;
`;

export const CategoryLabel = styled.h4`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.25rem;
  font-weight: ${Styles.fontWeight.normal};
`;
